import React from 'react'

import Box from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'

import { DEFAULT_DONUT_SIZE, DEFAULT_STROKE_WIDTH } from '../../constants'

export interface SingleSegmentDonutProps {
  children: React.ReactNode
  color: string
  percent: number
  size?: number
  strokeWidth?: number
  backgroundStrokeColor?: string
}

const SingleSegmentDonut: React.FC<SingleSegmentDonutProps> = ({
  color = '',
  percent = 0,
  size = DEFAULT_DONUT_SIZE,
  strokeWidth = DEFAULT_STROKE_WIDTH,
  children,
  backgroundStrokeColor,
}) => {
  const theme = useTheme()

  const radius = (size - strokeWidth) / 2
  const offset = -90
  const limitedPercent = percent > 100 ? 100 : percent
  const length = 2 * Math.PI * radius * (1 - limitedPercent / 100)
  const halfSize = size / 2

  return (
    <Box
      className="mx-cmn-single-segment-donut"
      height={size}
      mt={-8}
      position="relative"
      width={size}
    >
      <svg height={size} width={size}>
        <circle
          cx={halfSize}
          cy={halfSize}
          fill="none"
          r={radius}
          stroke={backgroundStrokeColor ? backgroundStrokeColor : theme.palette.grey[300]}
          strokeWidth={strokeWidth}
        />

        <circle
          cx={halfSize}
          cy={halfSize}
          fill="none"
          r={radius}
          stroke={color}
          strokeDasharray={2 * Math.PI * radius}
          strokeDashoffset={length}
          strokeWidth={strokeWidth}
          transform={`rotate(${offset}, ${halfSize}, ${halfSize})`}
        />
      </svg>
      <Box
        className="mx-cmn-single-segment-donut-children"
        left="50%"
        position="absolute"
        sx={{ transform: 'translate(-50%, -50%)' }}
        textAlign="center"
        top="50%"
      >
        {children}
      </Box>
    </Box>
  )
}

export default SingleSegmentDonut
